import CONST from '@src/CONST';

export default CONST.WEB_PAGINATION_SIZE;
